import {useLocale} from "@/lib/api/query";
import {Flex} from "antd";
import {useMemo} from "react";
import {Select} from "@/theme/ui";
import Image from 'next/image'
const localeProps = (name, key, icon) =>{
    return{
        label: (
            <>
                <Flex
                    gap={5}
                    align={'center'}
                >
                    {icon}
                    <div>
                        {name}
                    </div>
                </Flex>
            </>
        ),
        value: key,
        icon: icon,
    }
}

const getLocalesProps = (locale) =>{
    switch (locale){
        case 'cn':
            return localeProps('Chinese', 'cn', <Image style={{borderRadius: "50%"}} src={'/icon/flag/Language=CN.svg'} alt={'Language=CN'} width={20} height={20}/>)
        case 'de':
            return localeProps('German', 'de', <Image style={{borderRadius: "50%"}} src={'/icon/flag/Language=DE.svg'} alt={'Language=DE'} width={20} height={20}/>)
        case 'en':
            return localeProps('English', 'en', <Image style={{borderRadius: "50%"}} src={'/icon/flag/Language=US.svg'} alt={'Language=US'} width={20} height={20}/>)
        case 'es':
            return localeProps('Spanish', 'es', <Image style={{borderRadius: "50%"}} src={'/icon/flag/Language=ES.svg'} alt={'Language=ES'} width={20} height={20}/>)
        case 'fr':
            return localeProps('French', 'fr', <Image style={{borderRadius: "50%"}} src={'/icon/flag/Language=FR.svg'} alt={'Language=FR'} width={20} height={20}/>)
        case 'it':
            return localeProps('Italian', 'it', <Image style={{borderRadius: "50%"}} src={'/icon/flag/Language=IT.svg'} alt={'Language=IT'} width={20} height={20}/>)
        case 'pl':
            return localeProps('Polish', 'pl', <Image style={{borderRadius: "50%"}} src={'/icon/flag/Language=PL.svg'} alt={'Language=PL'} width={20} height={20}/>)
        case 'ro':
            return localeProps('Romanian', 'ro', <Image style={{borderRadius: "50%"}} src={'/icon/flag/Language=RO.svg'} alt={'Language=RO'} width={20} height={20}/>)
        case 'ru':
            return localeProps('Russian', 'ru', <Image style={{borderRadius: "50%"}} src={'/icon/flag/Language=RU.svg'} alt={'Language=RU'} width={20} height={20}/>)
        case 'tr':
            return localeProps('Turkish', 'tr', <Image style={{borderRadius: "50%"}} src={'/icon/flag/Language=TR.svg'} alt={'Language=TR'} width={20} height={20}/>)
        case 'ua':
            return localeProps('Ukrainian', 'ua', <Image style={{borderRadius: "50%"}} src={'/icon/flag/Language=UA.svg'} alt={'Language=UA'} width={20} height={20}/>)
        default:
            return localeProps('English', 'en', <Image style={{borderRadius: "50%"}} src={'/icon/flag/Language=US.svg'} alt={'Language=US'} width={20} height={20}/>)
    }
}

export const LocaleSwitch = ({...rest}) => {
    const {locale, locales} = useLocale()

    const options = useMemo(()=>{
        return locales.map((item)=>(getLocalesProps(item)))
    }, [locales.length])

    return (
        <>
            <Select
                style={{
                    width: 120,
                }}
                defaultValue={locale}
                optionLabelProp="label"
                options={options}
                {...rest}
            />
        </>
    );
}